import { RemoteDiagnosticsStatus } from '../../../projects/client';

export enum OtxProcedureFileName {
  BackupAndRestore = 'com.b2b.BackupAndRestore',
  DTCErrorSettingCondition = 'com.b2b.GetDTCErrorSettingCondition',
}

export enum OtxProcedureName {
  BackupConfiguration = 'BackupConfiguration',
  DTCErrorSettingCondition = 'getDTCErrorSettingCondition',
  RestoreConfiguration = 'RestoreConfiguration',
}

export enum OtxProcedureType {
  BackupConfiguration = 'BackupConfiguration',
  DTCErrorSettingCondition = 'DTCErrorSettingCondition',
  RestoreConfiguration = 'RestoreConfiguration',
}

export interface DtcVdds {
  dtcName: string;
  vddNames: string[];
}

export interface OtxGenericResponse<T> {
  outResultStructure: T[];
}

export interface OtxGenericInput<T> {
  otxFileName: OtxProcedureFileName;
  otxProcedureName: OtxProcedureName;
  otxParameters: T;
}

export interface CurComChannel {
  LogicalLink: string;
  Interface: string;
  Resource: string;
  EcuVariantName: string;
}

// GetDTCErrorSettingCondition input params
export interface OtxGetDTCErrorSettingConditionParameters {
  curComChannel: CurComChannel;
  listOfDTC: string[];
}

export interface OtxGetDTCErrorSettingConditionResponseStructure {
  '@parent': string;
  '@index': string;
  '@depth': string;
  '@children'?: string;
  type?: string;
  DTC?: string;
  legacyCodeValue?: string;
  VDD?: string;
}

// namespace: com.b2b.BackupAndRestore, procedure-name: BackupConfiguration
export interface OtxBackupConfigurationParameters {
  curComChannel: CurComChannel;
  folderPath: string;
}

export interface BackupConfigurationResult {
  backupListOfResultStructures: OtxBackupConfigurationResponseStructure[];
  listOfFailedVddsWhileReading: string[];
  listOfSuccessfullVddsWhilreReading: string[];
  outputFilePath: string;
  resultStatus: string;
}

export interface OtxBackupConfigurationResponseStructure {
  // first element in an array
  RES?: string;
  '@index'?: string;
  '@depth'?: string;
  request_parameter_value?: string;
  securitystatus?: string;
  type?: string;
  request_parameter_name?: string;
  '@parent'?: string;
  service?: string;
  ecu?: string;
  requestDate?: string;
  ecuvariant?: string;
  '@children'?: string;
  REQ?: string;
  // all elements except first
  semantic?: string;
  path?: string;
  unit?: string;
  translationid?: string;
  dopname?: string;
  name?: string;
  value?: string;
}

// namespace: com.b2b.BackupAndRestore, procedure-name: RestoreConfiguration
export interface OtxRestoreConfigurationParameters {
  comChannel: CurComChannel;
  filePath?: string; // optional - should not be provided if we use restoreListOfResultStructures
  // for restoreListOfResultStructures no white characters allowed, if empty, [] should be passed
  restoreListOfResultStructures: OtxBackupConfigurationResponseStructure[];
}

export interface RestoreConfigurationResult {
  listOfSuccessfulVddsWhileRestoring: string[];
  listOfFailedVddsWhileRestoring: string[];
  resultStatus: string;
}

export interface RemoteDiagnosticsWebsocketResponse<T> {
  requestId: string;
  status: RemoteDiagnosticsStatus;
  date: string;
  data: T;
  vdd: string;
  logicalLink: string;
  cycle: number;
  type: string;
  index: number;
}
